import { useState, useEffect } from 'react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { ARC } from '@lba-dev/package.local-globals/historyCat';

import api from '../../../api';

const useArchiveHistory = (artisanId, users) => {
  const [archiveData, setArchiveData] = useState({
    user: '',
    reason: '',
    date: '',
    loading: true,
  });

  useEffect(() => {
    if (!artisanId) {
      setArchiveData((prev) => ({ ...prev, loading: false }));
      return;
    }

    api.history
      .custom('getSpecificHistory')
      .post({
        id: artisanId,
        filter: [ARC],
      })
      .then((res) => {
        const result = !!res.body().length && res.body()[0].data();
        if (!result) {
          setArchiveData({
            user: '',
            reason: '',
            date: '',
            loading: false,
          });
          return;
        }

        const user = users?.find((u) => u._id === result.userId);

        setArchiveData({
          user: user ? user.login : '',
          reason: result.text === 'Autre' ? result.comment : result.text,
          date: dayjs(result.date).format('L [à] HH:mm'),
          loading: false,
        });
      })
      .catch(() => {
        setArchiveData({
          user: '',
          reason: '',
          date: '',
          loading: false,
        });
      });
  }, [artisanId, users]);

  return archiveData;
};

export default useArchiveHistory;
